import React from 'react';
import Rodal from 'rodal';
import { IApplication } from '../types';

type Props = {
  show: boolean,
  submitting: boolean,
  application: IApplication | null,
  onClose: () => void,
  onConfirm: () => void,
};

const EliminateApplicationModal = ({
  show,
  submitting,
  application,
  onClose,
  onConfirm,
}: Props) => (
  <Rodal
    closeOnEsc
    width={560}
    height={330}
    visible={show}
    onClose={onClose}
    className="convocation-modal"
    customStyles={{ padding: 0, borderRadius: 18, overflow: 'hidden' }}
  >
    <div className="cvm-container">
      <div className="cvm-header">
        <span className="cvm-kicker">Finalização</span>
        <h2>Marcar como Eliminado</h2>
      </div>
      <div className="cvm-body">
        <p className="cvm-summary">
          O candidato <b>{application ? (application.assumed_name || application.real_name) : ''}</b> ficará
          com o status <b>Eliminado</b> e sai da disputa pelas vagas. Use para quem não enviou os
          documentos ou cuja documentação não atendeu ao edital dentro do prazo.
        </p>
        <p className="cvm-summary">Essa ação não poderá ser desfeita por aqui (só pelo Admin).</p>
      </div>
      <div className="cvm-footer">
        <button className="btn btn-black" type="button" onClick={onClose}>Cancelar</button>
        <div className="cvm-footer-right">
          <button
            className="btn btn-primary"
            type="button"
            disabled={submitting}
            onClick={onConfirm}
          >
            {submitting ? 'Salvando...' : 'Marcar como Eliminado'}
          </button>
        </div>
      </div>
    </div>
  </Rodal>
);

export default EliminateApplicationModal;
